import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-minus",
  "use": "icon-minus-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-minus\">\n<path d=\"M2.5 10.625H17.5C17.6825 10.625 17.8323 10.5665 17.9494 10.4494C18.0665 10.3323 18.125 10.1825 18.125 10C18.125 9.8175 18.0665 9.66771 17.9494 9.55063C17.8323 9.43354 17.6825 9.375 17.5 9.375H2.5C2.3175 9.375 2.16771 9.43354 2.05062 9.55063C1.93354 9.66771 1.875 9.8175 1.875 10C1.875 10.1825 1.93354 10.3323 2.05062 10.4494C2.16771 10.5665 2.3175 10.625 2.5 10.625Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol